module.exports = __webpack_public_path__ + "static/media/desk.727bb02c.jpg";